// src/components/atoms/FloatingActionButton/index.tsx
import React from 'react';
import { Fab, FabProps, Tooltip } from '@mui/material';
import styles from '@/components/atoms/FloatingActionButton/floatingActionButton.module.css';

interface FloatingActionButtonProps extends Omit<FabProps, 'className'> {
  icon: React.ReactNode;
  tooltip?: string;
  position?: 'bottomRight' | 'bottomLeft' | 'topRight' | 'topLeft';
  className?: string;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  icon,
  tooltip,
  position = 'bottomRight',
  className = '',
  ...fabProps
}) => {
  const buttonContent = (
    <Fab className={`${styles.fab} ${styles[position]} ${className}`} {...fabProps}>
      {icon}
    </Fab>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="left">
        {buttonContent}
      </Tooltip>
    );
  }

  return buttonContent;
};

export default FloatingActionButton;
